module.exports = __webpack_public_path__ + "img/clover.8c1e0f40.png";